// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__20Q_O","skeletonItem":"styles_skeletonItem__2cNl2","p3m3":"styles_p3m3__3TL3N","shimmer":"styles_shimmer__2zDph","itil":"styles_itil__1FuxT"};